
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { confirmCodeApi, LoginPhoneNumberApi, RegisterApi, RegisterConfirmCode } from '../../../Api/ClientServices';
import Button from '../../../Components/Button/Button';
import Input from '../../../Components/Input/Input'
import Timer from '../../../Components/Timer/Timer';
import { errorToast, succToast } from '../../../Utils/Toast/Toast';
import Style from '../Auth.module.css'

const ConfirmCode = (props) => {
    
    const history=useHistory('')
    const[userName,setUserName]=useState(props.location.state.name)
    const[userLastname,setLastname]=useState(props.location.state.lastname)
    const[email,setEmail]=useState(props.location.state.email)
    const[resend,setResend]=useState(false)
    const[phoneNumber,setPhoneNumber]=useState(props.location.state.phoneNumber)
    const[remainTime,setReaminTime]=useState('')
    let objectSize=Object.keys(props.location.state).length
    useEffect(()=>{
        getCode()
        
    },[])
    
    const getCode=()=>{
        
        let info={
            phone:phoneNumber
        }
        if(objectSize===1){
            LoginPhoneNumberApi(info,(succ)=>{
                if(succ.status===1){
                    succToast(succ.message)
                    setReaminTime(succ.remaining_time)
                    setResend(false)
                    setPhoneNumber(succ.phone)
                    setTimeout(()=>setResend(true),parseInt(`${succ.remaining_time}000`))
                }
                else if(succ.message==='شماره وارد شده اشتباه است!'||succ.message==='کاربری یافت نشد!'){
                    errorToast(succ.message)
                    setTimeout(()=>history.push('./login'),1000)
                }
                else{
                    errorToast(succ.message)
                    setReaminTime(succ.remaining_time)
                    setPhoneNumber(succ.phone)
                    setTimeout(()=>setResend(true),parseInt(`${succ.remaining_time}000`))
                }
            })
        }
        else{
            RegisterConfirmCode(info,(succ)=>{
                if(succ.status===1){
                    succToast(succ.message)
                    setReaminTime(succ.remaining_time)
                    setResend(false)
                    setPhoneNumber(succ.phone)
                    setTimeout(()=>setResend(true),parseInt(`${succ.remaining_time}000`))
                }
                else if(succ.message==='شماره وارد شده اشتباه است!'||succ.message==='قبلاً ثبت نام شده است!' ){
                    errorToast(succ.message)
                    setTimeout(()=>history.push('./login'),1000)
                }
                else{
                    errorToast(succ.message)
                    setReaminTime(succ.remaining_time)
                    setPhoneNumber(succ.phone)
                    setTimeout(()=>setResend(true),parseInt(`${succ.remaining_time}000`))
                }
            })

        }

    }
    


    
    const { register, handleSubmit, formState: { errors } } = useForm();
    const onSubmit = (data)=>{
        let info={
            code:data.code,
            phone:phoneNumber
        }
        confirmCodeApi(info,(succ)=>{
            if(succ.status===1){
                succToast(succ.message)
                localStorage.setItem('clientElectronicToken', succ.token);
                setTimeout(()=>history.push('/'),100)
            }
            else if(succ.status===2){
                localStorage.setItem('clientElectronicToken', succ.token);
                RegisterHandler()
            }
            else{
                errorToast(succ.message)
                setPhoneNumber(succ.phone)
                setReaminTime(succ.remaining_time)
                setTimeout(()=>setResend(true),parseInt(`${succ.remaining_time}000`))
            }
        })
    };
    const RegisterHandler=()=>{
        let userInfo={
            first_name:userName,
            last_name:userLastname,
            email:email
        }
        RegisterApi(userInfo,(succ)=>{
            if(succ.status===1){
                succToast(succ.message)
                setTimeout(()=>history.push('/'))
                
            }
            else{
                errorToast(succ.message)
            }
        })
    }
    return (
        <div className={`pageHolder ${Style.LoginPageHolder}`}>
            <form onSubmit={handleSubmit(onSubmit)} className='formHolder'>
                <img className={Style.ImageHolder} src="/Assets/Images/Regular/Logo.png" alt="ElectronicSteps" />
                <label htmlFor="confirm" > :کد دریافتی را واردکنید </label>
                <Input 
                id='confirm' 
                {...register("code", { required: true })} 
                 type={'number'} 
                inputtype={errors.code ? "valid" : "text"}
                style={{textAlign:'center'}}
                /> 
                {resend?<p className={Style.resend} onClick={()=>getCode()}>ارسال دوباره</p>:<Timer  Time={remainTime} />}
                
                <Button Value='ورود' ClassBtn={'confirmBtn'}/>

                
            </form>
        </div>
    )
}

export default ConfirmCode
